import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const list: ThemeUICSSObject = {
  accordionAsyncRenderer: {
    '.iconButton': {
      color: 'var(--theme-ui-colors-buttons-primary-backgroundColor)',
      backgroundColor: 'var(--theme-ui-colors-white)',
    },
    '.iconButton:hover': {
      color: 'var(--theme-ui-colors-white)',
      backgroundColor: 'var(--theme-ui-colors-buttons-primary-backgroundColor)',
    },
  },
  table: {
    thead: {
      '.additionalColumn': {
        width: '50px',
        maxWidth: '50px',
        minWidth: '50px',
      },
    },
    '.rowSeparator.non-selectable.responsiveTable__row': {
      height: '10px',
      backgroundColor:
        'var(--theme-ui-colors-buttons-outline-disabled-backgroundColor)',
    },
    tbody: {
      tr: {
        '&.proCompleted': {
          td: {
            fontWeight: 'bold',
          },
        },
        '&.proSuspended': {
          td: {
            color: 'palette.secondary.main',
          },
        },
        '&.proFinalized': {
          td: {
            color: 'palette.error.main',
          },
        },
        '&.proCancelled': {},

        '&.expired': {
          color: 'priorityUrgent',
          '&:hover': {
            color: 'priorityUrgent',
          },
        },
      },
    },

    '.row__separator__cell': {
      backgroundColor: 'palette.secondary.light',
    },
  },

  '.hidden': {
    display: 'none',
  },
  '&.overflowHidden': {
    overflow: 'hidden',
  },
};

export default list;
